module.exports = __webpack_public_path__ + "img/download.373d3169.svg";